import script from "./MinLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MinLayout.vue?vue&type=script&setup=true&lang=js"

import "./MinLayout.vue?vue&type=style&index=0&id=6a6fc76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6fc76e"]])

export default __exports__